import { render, staticRenderFns } from "./SvgIcon.vue?vue&type=template&id=8f2e3b44&scoped=true&"
import script from "./SvgIcon.vue?vue&type=script&lang=ts&"
export * from "./SvgIcon.vue?vue&type=script&lang=ts&"
import style0 from "./SvgIcon.vue?vue&type=style&index=0&id=8f2e3b44&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8f2e3b44",
  null
  
)

export default component.exports